import { takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as refSlice from './referenceSlice';
import * as uiSlice from '../../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from "../../../Auth";
import { getAllReferenceByKindApi, getAllReferences, getAllReferencesKinds } from './referenceAPI';


export function* onLoadReferenceByKindStartAsync({ payload }){

    try{
        
        yield put(refSlice.actions.startCall({ callType: refSlice.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getAllReferenceByKindApi, reqBody, payload.kindId);        

        if(response.status === 200){
            let totalCount = response.data.length;
            let entities = response.data;
            let kindId = payload.kindId;
            yield put(refSlice.actions.referencesByKindFetched({ totalCount, entities, kindId }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            let errorMsg = "There was an error retrieving reference information.";
            
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uiSlice.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uiSlice.actions.error({ status, msg }));

            }

            // yield put(uiSlice.actions.showNotification({
            //     status:"error",
            //     title:"Error",
            //     message: errorMsg
            // }));

            yield put(refSlice.actions.catchError({
                callType: refSlice.callTypes.list,
                error: errorMsg
            }));
        }
    }

};

export function* onLoadAllReferenceStartAsync({ payload }){

    try{
        
        yield put(refSlice.actions.startCall({ callType: refSlice.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);
        
        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getAllReferences, reqBody);        

        if(response.status === 200){
            let references = response.data;
            yield put(refSlice.actions.allReferencesFetched({ references }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            let errorMsg = "There was an error retrieving reference information.";

            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uiSlice.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uiSlice.actions.error({ status, msg }));

            }

            yield put(uiSlice.actions.showNotification({
                status:"error",
                title:"Error",
                message: errorMsg
            }));

            yield put(refSlice.actions.catchError({
                callType: refSlice.callTypes.list,
                error: errorMsg
            }));
        }
    }

};

export function* onLoadAllReferenceKindsStartAsync({ payload }){

    try{
        
        yield put(refSlice.actions.startCall({ callType: refSlice.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getAllReferencesKinds, reqBody);        

        if(response.status === 200){
            let refKinds = response.data;
            yield put(refSlice.actions.referenceKindsFetched({ refKinds }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            
            let errorMsg = "There was an error retrieving reference information.";

            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uiSlice.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uiSlice.actions.error({ status, msg }));

            }

            yield put(uiSlice.actions.showNotification({
                status:"error",
                title:"Error",
                message: errorMsg
            }));

            yield put(refSlice.actions.catchError({
                callType: refSlice.callTypes.list,
                error: "There was an error retrieving reference information."
            }));
        }
    }

};

export const actionTypes = {
    FetchReferenceByKind: "[FetchReferenceByKind] Fetch Reference By Kind API Action",
    FetchAllReferences: "[FetchAllReferences] Fetch All References API Action",
    FetchReferenceKinds: "[FetchAllReferenceKinds] Fetch All Reference Kinds API Action"
};

export const actions = {

    fetchReferenceByKind: (kindId) => ({ type: actionTypes.FetchReferenceByKind, payload: { kindId: kindId } }),
    fetchAllReferences: () => ({ type: actionTypes.FetchAllReferences, payload: { undefined } }),
    fetchReferenceKinds: () => ({ type: actionTypes.FetchReferenceKinds, payload: { undefined } })
  
};

export function* fetchReferenceByKind(){

    yield takeEvery(actionTypes.FetchReferenceByKind, onLoadReferenceByKindStartAsync);    
};

export function* fetchAllReferences(){

    yield takeEvery(actionTypes.FetchAllReferences, onLoadAllReferenceStartAsync);
};

export function* fetchReferenceKinds(){

    yield takeEvery(actionTypes.FetchReferenceKinds, onLoadAllReferenceKindsStartAsync);
};

const fSagas = [
    fork(fetchReferenceByKind),
    fork(fetchAllReferences),
    fork(fetchReferenceKinds)
];

export function* saga(){
    yield all ([...fSagas]);
};
